import React from 'react';
import { withRouter } from '../../../RouterCompatibility';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PayoutItemContent from './PayoutItemContent';
import { actions } from './PayoutItemContent.actions';
import {
    mainSelector,
    isEmpty
} from './PayoutItemContent.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    isEmpty: isEmpty,
    data: mainSelector,
});

const PayoutItemContentComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.publisherPayouts.loading
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            getPayout: actions.getPayout
        };
    }
)(withRouter(PayoutItemContent));

export default PayoutItemContentComponent;
